import React from "react";
import CoverLayout from "pages/authentication/components/CoverLayout";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

const ErrorFallback = () => (
  <CoverLayout>
    <MDBox>
      <MDTypography variant="h2" mb={6}>
        Authentication Error
      </MDTypography>
      <MDTypography variant="p">
        There was a problem processing your authentication request. Please try again or contact
        support if the issue persists.
      </MDTypography>

      <MDButton color="primaryRed" href="/sign-in" sx={{ marginTop: "24px" }}>
        Return to sign in
      </MDButton>
    </MDBox>
  </CoverLayout>
);

export default ErrorFallback;
